import '../pages/project';
import '../pages/grants';
import '../pages/video-player';

export default {
  init() {
    $('body').on('load', function () {
      const enableTopNotice = localStorage.getItem('enableTopNotice');
      if (enableTopNotice === 'true' || enableTopNotice === '') {
        localStorage.setItem('enableTopNotice', 'true');
      }
    })
    // JavaScript to be fired on all pages
    const $hamburger_menu = $('.hamburger-menu');
    $hamburger_menu.on('click', function() {
      $('.banner img').toggleClass('img-drop-down');
      setTimeout($('.group-action-buttom-menu').toggleClass('show-drop-down'), 2000);
      $hamburger_menu.find('.hamburger').toggleClass('is-active');
      $('.banner').toggleClass('absolute').toggleClass('fixed');
      $('.nav-menu').slideToggle('fast');
      $('body').toggleClass('fixed xl:relative');
    });

    $('.tab').on('click', function() {
      const tab = $('.tab');
      const tab_content = $('.tab-content');
      const target = $(this).attr('data-target');
      const position = $('#panels').offset().top;
      console.log(position);
      $('body, html').animate({
        scrollTop: position - 50,
      }, 1000);

      tab.removeClass('active');
      tab_content.removeClass('active');

      $('.'+target).addClass('active');
      $(this).addClass('active');
    });

    //fixed sub menu bar when it reached the top
    if ($('#sub-menu').length) {
      let top_menu = $('#sub-menu').offset().top;
      const $window = $(window);
      $window.scroll(function() {

      if($window.scrollTop() > top_menu + 200) {
        $('#sub-menu').addClass('sticky-menu').removeClass('default-sub-menu-container');
        $('#sub-menu-phantom').show();
      }
      else {
        $('#sub-menu').removeClass('sticky-menu').addClass('default-sub-menu-container');
        $('#sub-menu-phantom').hide();
      }
      });
    }

    //remove the action bar when close button is clicked
    $('.close').on('click', function (event) {
      event.preventDefault();
      $('#top-menu').slideUp('300');
      localStorage.setItem('enableTopNotice', 'false');
    });

    //replace the message svg with fly svg
    $('#newsletter input').on('keyup', function () {
      const input_val = $(this).val();
      console.log('hello', $(this).siblings('svg'))

      if (input_val.length > 0) {
        $(this).siblings('.output').removeClass('active');
        $(this).siblings('.input').addClass('active');
      }
      else {
        $(this).siblings('.output').addClass('active');
        $(this).siblings('.input').removeClass('active');
      }
    });

    //scroll to top smoothly
    $('#backToTop').on('click', function() {
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false;
    });

    //toggle see more options
    $('.toggleDateOptions').on('click', function(event) {
      event.preventDefault();

      const check_hidden = $(this).parent('.see-more-options').siblings('#award-date-filter').hasClass('hidden');

      $(this).parent('.see-more-options').siblings('#award-date-filter').toggleClass('hidden');

      if (check_hidden) {
        $(this).text('See less options');

      } else $(this).text('See more options');
    });

    //toggle see more options
    $('.toggleAmountOptions').on('click', function(event) {
      event.preventDefault();

      const check_hidden = $(this).parent('.see-more-options').siblings('#grant-amount-filter').hasClass('hidden');

      $(this).parent('.see-more-options').siblings('#grant-amount-filter').toggleClass('hidden');

      if (check_hidden) {
        $(this).text('See less options');

      } else $(this).text('See more options');
    });

    //toggle
    $('.grant-amount .title').click(function() {
      $(this).siblings('.content').slideToggle();
      $(this).find('.show-arrow').toggleClass('rotate180');
    });

    //click the video
    $('#home-video').click();
    $(document).ready(function () {
      $('#home-video').trigger('click');
      $('#home-video').click();
    })

    //submit newsletter subscription
    $('#newsletter svg').on('click', function(event) {
      event.preventDefault();
      $('.mc4wp-form').submit()
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //filter the dates and categories

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js